import { render, staticRenderFns } from "./ModalConfirmarDataAgendamento.vue?vue&type=template&id=667d8ee8&scoped=true"
import script from "./ModalConfirmarDataAgendamento.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmarDataAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalConfirmarDataAgendamento.vue?vue&type=style&index=0&id=667d8ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d8ee8",
  null
  
)

export default component.exports